import PropTypes from "prop-types"
import { Menu, MenuItem, Tooltip } from "@mui/material"
import { map, toLower } from "lodash"

export default function TableMenu({ anchor, item, id, title, editIsEnabled, deleteIsEnabled, additionalOptions, onClose, setEditedId, setDialog, startDelete }) {
  const editDisabled = editIsEnabled && !editIsEnabled(item)
  const deleteDisabled = deleteIsEnabled && !deleteIsEnabled(item)

  return <Menu
    anchorEl={anchor}
    open
    onClose={onClose}
  >
    <MenuItem
      className="components_table-menu-item"
      disabled={editDisabled}
      title={editDisabled ? `You do not have the permission to edit ${toLower(title)}` : undefined}
      onClick={() => {
        if (!editDisabled) {
          setEditedId(id)
          setDialog("edit")
          onClose()
        }
      }}
    >
      Edit...
    </MenuItem>
    <MenuItem
      className="components_table-menu-item"
      disabled={deleteDisabled}
      title={editDisabled ? `You do not have the permission to remove ${toLower(title)}` : undefined}
      onClick={() => {
        if (!deleteDisabled) {
          startDelete(id)
          onClose()
        }
      }}
    >
      Remove...
    </MenuItem>
    {map(additionalOptions, option => {
      if (option.displayFor && !option.displayFor(item)) {
        return null
      }
      const isDisabled = option.disableFor && option.disableFor(item)

      const menuItem = <MenuItem
        key={option.id}
        disabled={isDisabled}
        onClick={() => {
          option.onClick(item)
          onClose()
        }}
      >
        {option.label}
      </MenuItem>

      return isDisabled && option.disabledText ? <Tooltip title={option.disabledText} key={option.id}>
        <span>{menuItem}</span>
      </Tooltip> : menuItem
    })}
  </Menu>
}

TableMenu.propTypes = {
  anchor: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  editIsEnabled: PropTypes.func,
  deleteIsEnabled: PropTypes.func,
  additionalOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    displayFor: PropTypes.func,
    onClick: PropTypes.func.isRequired,
  })),
  onClose: PropTypes.func.isRequired,
  setEditedId: PropTypes.func.isRequired,
  setDialog: PropTypes.func.isRequired,
  startDelete: PropTypes.func.isRequired,
}
